import JudgingLogin from './JudgingLogin';

export default JudgingLogin;
